export default {
  ABYSS: {
    symbol: 'ABYSS',
    name: 'ABYSS',
    decimals: 18,
    contractAddress: '0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6'
  },
  ANT: {
    name: 'Aragon',
    symbol: 'ANT',
    contractAddress: '0x960b236A07cf122663c4303350609A66A7B288C0',
    decimals: 18,
    fixRateEnabled: true
  },
  BAT: {
    symbol: 'BAT',
    name: 'Basic Attention Token',
    decimals: 18,
    contractAddress: '0x0d8775f648430679a709e98d2b0cb6250d2887ef'
  },
  BDG: {
    name: 'BitDegree',
    symbol: 'BDG',
    contractAddress: '0x1961b3331969ed52770751fc718ef530838b6dee',
    decimals: 18,
    fixRateEnabled: false
  },
  BETR: {
    name: 'BetterBetting',
    symbol: 'BETR',
    contractAddress: '0x763186eb8d4856d536ed4478302971214febc6a9',
    decimals: 18,
    fixRateEnabled: false
  },
  BKX: {
    name: 'Bankex',
    symbol: 'BKX',
    contractAddress: '0x45245bc59219eeaaf6cd3f382e078a461ff9de7b',
    decimals: 18,
    fixRateEnabled: false
  },
  BNT: {
    symbol: 'BNT',
    name: 'Bancor',
    decimals: 18,
    contractAddress: '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c'
  },
  BRD: {
    name: 'Bread',
    symbol: 'BRD',
    contractAddress: '0x558ec3152e2eb2174905cd19aea4e34a23de9ad6',
    decimals: 18,
    fixRateEnabled: true
  },
  CVC: {
    symbol: 'CVC',
    name: 'Civic',
    decimals: 8,
    contractAddress: '0x41e5560054824ea6b0732e656e3ad64e20e94e45'
  },
  DAI: {
    symbol: 'DAI',
    name: 'Dai Stablecoin',
    decimals: 18,
    contractAddress: '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359'
  },
  DCN: {
    name: 'Dentacoin',
    symbol: 'DCN',
    contractAddress: '0x08d32b0da63e2C3bcF8019c9c5d849d7a9d791e6',
    decimals: 0,
    fixRateEnabled: false
  },
  DENT: {
    name: 'Dent',
    symbol: 'DENT',
    contractAddress: '0x3597bfd533a99c9aa083587b074434e61eb0a258',
    decimals: 8,
    fixRateEnabled: true
  },
  DGD: {
    name: 'DigixDAO',
    symbol: 'DGD',
    contractAddress: '0xe0b7927c4af23765cb51314a0e0521a9645f0e2a',
    decimals: null,
    fixRateEnabled: true
  },
  DGTX: {
    name: 'Digitex Futures',
    symbol: 'DGTX',
    contractAddress: '0x1C83501478f1320977047008496DACBD60Bb15ef',
    decimals: 18,
    fixRateEnabled: false
  },
  DNT: {
    name: 'district0x',
    symbol: 'DNT',
    contractAddress: '0x0abdace70d3790235af448c88547603b945604ea',
    decimals: 18,
    fixRateEnabled: true
  },
  EDG: {
    name: 'Edgeless',
    symbol: 'EDG',
    contractAddress: '0x08711d3b02c8758f2fb3ab4e80228418a7f8e39c',
    decimals: 0,
    fixRateEnabled: true
  },
  ENJ: {
    symbol: 'ENJ',
    name: 'EnjinCoin',
    decimals: 18,
    contractAddress: '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c'
  },
  ETHOS: {
    name: 'ETHOS',
    symbol: 'ETHOS',
    contractAddress: '0x5af2be193a6abca9c8817001f45744777db30756',
    decimals: 8,
    fixRateEnabled: true
  },
  EURS: {
    symbol: 'EURS',
    name: 'STASIS EURS Token',
    decimals: 2,
    contractAddress: '0xdb25f211ab05b1c97d595516f45794528a807ad8'
  },
  FET: {
    name: 'Fetch',
    symbol: 'FET',
    contractAddress: '0x1d287cc25dad7ccaf76a26bc660c5f7c8e2a05bd',
    decimals: 18,
    fixRateEnabled: false
  },
  FUN: {
    name: 'FunFair',
    symbol: 'FUN',
    contractAddress: '0x419d0d8bdd9af5e606ae2232ed285aff190e711b',
    decimals: 8,
    fixRateEnabled: true
  },
  GNO: {
    symbol: 'GNO',
    name: 'Gnosis',
    decimals: 18,
    contractAddress: '0x6810e776880c02933d47db1b9fc05908e5386b96'
  },
  GNT: {
    name: 'Golem',
    symbol: 'GNT',
    contractAddress: '0xa74476443119A942dE498590Fe1f2454d7D4aC0d',
    decimals: 18,
    fixRateEnabled: true
  },
  GUP: {
    name: 'Guppy',
    symbol: 'GUP',
    contractAddress: '0xf7b098298f7c69fc14610bf71d5e02c60792894c',
    decimals: 3,
    fixRateEnabled: true
  },
  GUSD: {
    name: 'Gemini Dollar',
    symbol: 'GUSD',
    contractAddress: '0x056fd409e1d7a124bd7017459dfea2f387b6d5cd',
    decimals: 2,
    fixRateEnabled: true
  },
  HMQ: {
    name: 'Humaniq',
    symbol: 'HMQ',
    contractAddress: '0xcbcc0f036ed4788f63fc0fee32873d6a7487b908',
    decimals: 8,
    fixRateEnabled: true
  },
  HT: {
    name: 'Huobi token',
    symbol: 'HT',
    contractAddress: '0x6f259637dcd74c767781e37bc6133cd6a68aa161',
    decimals: 18,
    fixRateEnabled: false
  },
  KNC: {
    symbol: 'KNC',
    name: 'Kyber Network',
    decimals: 18,
    contractAddress: '0xdd974d5c2e2928dea5f71b9825b8b646686bd200'
  },
  LINK: {
    symbol: 'LINK',
    name: 'Chain Link',
    decimals: 18,
    contractAddress: '0x514910771af9ca656af840dff83e8264ecf986ca'
  },
  LRC: {
    symbol: 'LRC',
    name: 'Loopring',
    decimals: 18,
    contractAddress: '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd'
  },
  LUN: {
    name: 'Lunyr',
    symbol: 'LUN',
    contractAddress: '0xfa05A73FfE78ef8f1a739473e462c54bae6567D9',
    decimals: 18,
    fixRateEnabled: true
  },
  MANA: {
    symbol: 'MANA',
    name: 'Decentraland',
    decimals: 18,
    contractAddress: '0x0f5d2fb29fb7d3cfee444a200298f468908cc942'
  },
  MCO: {
    symbol: 'MCO',
    name: 'Crypto.com',
    decimals: 8,
    contractAddress: '0xb63b606ac810a52cca15e44bb630fd42d8d1d83d'
  },
  MKR: {
    symbol: 'MKR',
    name: 'Maker',
    decimals: 18,
    contractAddress: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2'
  },
  NEXO: {
    name: 'NEXO',
    symbol: 'NEXO',
    contractAddress: '0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206',
    decimals: 18,
    fixRateEnabled: true
  },
  NGC: {
    name: 'NAGA Coin',
    symbol: 'NGC',
    contractAddress: '0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131',
    decimals: 18,
    fixRateEnabled: false
  },
  NMR: {
    name: 'Numeraire',
    symbol: 'NMR',
    contractAddress: '0x1776e1f26f98b1a5df9cd347953a26dd3cb46671',
    decimals: 18,
    fixRateEnabled: false
  },
  NOAH: {
    name: 'Noah',
    symbol: 'NOAH',
    contractAddress: '0x58a4884182d9E835597f405e5F258290E46ae7C2',
    decimals: 18,
    fixRateEnabled: true
  },
  OMG: {
    symbol: 'OMG',
    name: 'OmiseGO',
    decimals: 18,
    contractAddress: '0xd26114cd6ee289accf82350c8d8487fedb8a0c07'
  },
  PAX: {
    symbol: 'PAX',
    name: 'Paxos Standard',
    decimals: 18,
    contractAddress: '0x8e870d67f660d95d5be530380d0ec0bd388289e1'
  },
  PAY: {
    symbol: 'PAY',
    name: 'TenX',
    decimals: 18,
    contractAddress: '0xb97048628db6b661d4c2aa833e95dbe1a905b280'
  },
  PLR: {
    name: 'Pillar',
    symbol: 'PLR',
    contractAddress: '0xe3818504c1b32bf1557b16c238b2e01fd3149c17',
    decimals: 18,
    fixRateEnabled: false
  },
  PMA: {
    name: 'PumaPay',
    symbol: 'PMA',
    contractAddress: '0x846c66cf71c43f80403b51fe3906b3599d63336f',
    decimals: 18,
    fixRateEnabled: true
  },
  POLY: {
    symbol: 'POLY',
    name: 'Polymath',
    decimals: 18,
    contractAddress: '0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec'
  },
  POWR: {
    symbol: 'POWR',
    name: 'Power Ledger',
    decimals: 6,
    contractAddress: '0x595832f8fc6bf59c85c527fec3740a1b7a361269'
  },
  PPT: {
    name: 'Populous',
    symbol: 'PPT',
    contractAddress: '0xd4fa1460f537bb9085d22c7bccb5dd450ef28e3a',
    decimals: 8,
    fixRateEnabled: true
  },
  PTOY: {
    name: 'Patientory',
    symbol: 'PTOY',
    contractAddress: '0x8ae4bf2c33a8e667de34b54938b0ccd03eb8cc06',
    decimals: 8,
    fixRateEnabled: false
  },
  R: {
    name: 'Revain',
    symbol: 'R',
    contractAddress: '0x48f775efbe4f5ece6e0df2f7b5932df56823b990',
    decimals: 0,
    fixRateEnabled: false
  },
  RCN: {
    name: 'Ripio Credit Network',
    symbol: 'RCN',
    contractAddress: '0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6',
    decimals: 18,
    fixRateEnabled: true
  },
  REP: {
    symbol: 'REP',
    name: 'Augur',
    decimals: 18,
    contractAddress: '0x1985365e9f78359a9b6ad760e32412f4a445e862'
  },
  RLC: {
    symbol: 'RLC',
    name: 'iExec RLC',
    decimals: 9,
    contractAddress: '0x607f4c5bb672230e8672085532f7e901544a7375'
  },
  SALT: {
    name: 'Salt',
    symbol: 'SALT',
    contractAddress: '0x4156D3342D5c385a87D264F90653733592000581',
    decimals: 8,
    fixRateEnabled: false
  },
  SNM: {
    name: 'SONM',
    symbol: 'SNM',
    contractAddress: '0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63',
    decimals: 18,
    fixRateEnabled: true
  },
  STORJ: {
    name: 'Storj',
    symbol: 'STORJ',
    contractAddress: '0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac',
    decimals: 8,
    fixRateEnabled: true
  },
  STX: {
    name: 'Stox',
    symbol: 'STX',
    contractAddress: '0x006bea43baa3f7a6f765f14f10a1a1b08334ef45',
    decimals: 18,
    fixRateEnabled: false
  },
  SUB: {
    name: 'Substratum',
    symbol: 'SUB',
    contractAddress: '0x12480E24eb5bec1a9D4369CaB6a80caD3c0A377A',
    decimals: 2,
    fixRateEnabled: false
  },
  SWT: {
    name: 'Swarm City',
    symbol: 'SWT',
    contractAddress: '0xb9e7f8568e08d5659f5d29c4997173d84cdf2607',
    decimals: 18,
    fixRateEnabled: false
  },
  TEL: {
    name: 'Telcoin',
    symbol: 'TEL',
    contractAddress: '0x85e076361cc813A908Ff672F9BAd1541474402b2',
    decimals: 2,
    fixRateEnabled: false
  },
  TRST: {
    name: 'Trustcoin',
    symbol: 'TRST',
    contractAddress: '0xcb94be6f13a1182e4a4b6140cb7bf2025d28e41b',
    decimals: 6,
    fixRateEnabled: false
  },
  TUSD: {
    symbol: 'TUSD',
    name: 'TrueUSD',
    decimals: 18,
    contractAddress: '0x8dd5fbce2f6a956c3022ba3663759011dd51e73e'
  },
  USDC: {
    symbol: 'USDC',
    name: 'USD Coin',
    decimals: 6,
    contractAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
  },
  USDT20: {
    name: 'Tether ERC20',
    symbol: 'USDT20',
    contractAddress: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    decimals: 6,
    fixRateEnabled: true
  },
  VIB: {
    name: 'Viberate',
    symbol: 'VIB',
    contractAddress: '0x2C974B2d0BA1716E644c1FC59982a89DDD2fF724',
    decimals: 18,
    fixRateEnabled: true
  },
  WAX: {
    symbol: 'WAX',
    name: 'Wax',
    decimals: 8,
    contractAddress: '0x39bb259f66e1c59d5abef88375979b4d20d98022'
  },
  WINGS: {
    name: 'Wings DAO',
    symbol: 'WINGS',
    contractAddress: '0x667088b212ce3d06a1b553a7221E1fD19000d9aF',
    decimals: 18,
    fixRateEnabled: true
  },
  WTC: {
    name: 'Waltonchain',
    symbol: 'WTC',
    contractAddress: '0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74',
    decimals: 18,
    fixRateEnabled: true
  },
  ZAP: {
    name: 'Zap',
    symbol: 'ZAP',
    contractAddress: '0x6781a0f84c7e9e846dcb84a9a5bd49333067b104',
    decimals: 18,
    fixRateEnabled: false
  },
  ZRX: {
    symbol: 'ZRX',
    name: '0x',
    decimals: 18,
    contractAddress: '0xe41d2489571d322189246dafa5ebde1f4699f498'
  },
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
    decimals: 18,
    contractAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
  },
  WETH: {
    symbol: 'WETH',
    name: 'Wrapped Ether',
    decimals: 18,
    contractAddress: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'
  },
  SNT: {
    symbol: 'SNT',
    name: 'Status Network',
    decimals: 18,
    contractAddress: '0x744d70fdbe2ba4cf95131626614a1763df805b9e'
  },
  ELF: {
    symbol: 'ELF',
    name: 'AELF',
    decimals: 18,
    contractAddress: '0xbf2179859fc6d5bee9bf9158632dc51678a4100e'
  },
  REQ: {
    symbol: 'REQ',
    name: 'Request',
    decimals: 18,
    contractAddress: '0x8f8221afbb33998d8584a2b05749ba73c37a938a'
  },
  RDN: {
    symbol: 'RDN',
    name: 'Raiden Network',
    decimals: 18,
    contractAddress: '0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6'
  },
  APPC: {
    symbol: 'APPC',
    name: 'AppCoins',
    decimals: 18,
    contractAddress: '0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db'
  },
  ENG: {
    symbol: 'ENG',
    name: 'Enigma',
    decimals: 8,
    contractAddress: '0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4'
  },
  BQX: {
    symbol: 'BQX',
    name: 'ETHOS',
    decimals: 8,
    contractAddress: '0x5af2be193a6abca9c8817001f45744777db30756'
  },
  AST: {
    symbol: 'AST',
    name: 'AirSwap',
    decimals: 4,
    contractAddress: '0x27054b13b1b798b345b591a4d22e6562d47ea75a'
  },
  DGX: {
    symbol: 'DGX',
    name: 'Digix Gold',
    decimals: 9,
    contractAddress: '0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf'
  },
  STORM: {
    symbol: 'STORM',
    name: 'Storm',
    decimals: 18,
    contractAddress: '0xd0a4b8946cb52f0661273bfbc6fd0e0c75fc6433'
  },
  IOST: {
    symbol: 'IOST',
    name: 'IOStoken',
    decimals: 18,
    contractAddress: '0xfa1a856cfa3409cfa145fa4e20eb270df3eb21ab'
  },
  MOT: {
    symbol: 'MOT',
    name: 'Olympus Labs',
    decimals: 18,
    contractAddress: '0x263c618480dbe35c300d8d5ecda19bbb986acaed'
  },
  ABT: {
    symbol: 'ABT',
    name: 'ArcBlock',
    decimals: 18,
    contractAddress: '0xb98d4c97425d9908e66e53a6fdf673acca0be986'
  },
  BLZ: {
    symbol: 'BLZ',
    name: 'Bluzelle',
    decimals: 18,
    contractAddress: '0x5732046a883704404f284ce41ffadd5b007fd668'
  },
  ELEC: {
    symbol: 'ELEC',
    name: 'ElectrifyAsia',
    decimals: 18,
    contractAddress: '0xd49ff13661451313ca1553fd6954bd1d9b6e02b9'
  },
  BBO: {
    symbol: 'BBO',
    name: 'Bigbom',
    decimals: 18,
    contractAddress: '0x84f7c44b6fed1080f647e354d552595be2cc602f'
  },
  LBA: {
    symbol: 'LBA',
    name: 'Cred',
    decimals: 18,
    contractAddress: '0xfe5f141bf94fe84bc28ded0ab966c16b17490657'
  },
  POE: {
    symbol: 'POE',
    name: 'Po.et',
    decimals: 8,
    contractAddress: '0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195'
  },
  DTA: {
    symbol: 'DTA',
    name: 'Data',
    decimals: 18,
    contractAddress: '0x69b148395ce0015c13e36bffbad63f49ef874e03'
  },
  LEND: {
    symbol: 'LEND',
    name: 'EthLend',
    decimals: 18,
    contractAddress: '0x80fb784b7ed66730e8b1dbd9820afd29931aab03'
  },
  MTL: {
    symbol: 'MTL',
    name: 'Metal',
    decimals: 8,
    contractAddress: '0xf433089366899d83a9f26a773d59ec7ecf30355e'
  },
  COFI: {
    symbol: 'COFI',
    name: 'CoinFi',
    decimals: 18,
    contractAddress: '0x3136ef851592acf49ca4c825131e364170fa32b3'
  },
  MOC: {
    symbol: 'MOC',
    name: 'Moss Land',
    decimals: 18,
    contractAddress: '0x865ec58b06bf6305b886793aa20a2da31d034e68'
  },
  MAS: {
    symbol: 'MAS',
    name: 'MidasProtocol',
    decimals: 18,
    contractAddress: '0x23ccc43365d9dd3882eab88f43d515208f832430'
  },
  DAT: {
    symbol: 'DAT',
    name: 'Datum',
    decimals: 18,
    contractAddress: '0x81c9151de0c8bafcd325a57e3db5a5df1cebf79c'
  },
  REN: {
    symbol: 'REN',
    name: 'Republic',
    decimals: 18,
    contractAddress: '0x408e41876cccdc0f92210600ef50372656052a38'
  },
  QKC: {
    symbol: 'QKC',
    name: 'QuarkChain',
    decimals: 18,
    contractAddress: '0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664'
  },
  DCC: {
    symbol: 'DCC',
    name: 'Distributed Credit Chain',
    decimals: 18,
    contractAddress: '0xffa93aacf49297d51e211817452839052fdfb961'
  },
  EKO: {
    symbol: 'EKO',
    name: 'EchoLink',
    decimals: 18,
    contractAddress: '0xa6a840e50bcaa50da017b91a0d86b8b2d41156ee'
  },
  OST: {
    symbol: 'OST',
    name: 'Open Simple Token',
    decimals: 18,
    contractAddress: '0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca'
  },
  DTH: {
    symbol: 'DTH',
    name: 'Dether',
    decimals: 18,
    contractAddress: '0x5adc961d6ac3f7062d2ea45fefb8d8167d44b190'
  },
  PT: {
    symbol: 'PT',
    name: 'Promotion Token',
    decimals: 18,
    contractAddress: '0x094c875704c14783049ddf8136e298b3a099c446'
  },
  INF: {
    symbol: 'INF',
    name: 'InfinitusTokens',
    decimals: 18,
    contractAddress: '0x00e150d741eda1d49d341189cae4c08a73a49c95'
  },
  TTC: {
    symbol: 'TTC',
    name: 'TTC Protocol',
    decimals: 18,
    contractAddress: '0x9389434852b94bbad4c8afed5b7bdbc5ff0c2275'
  },
  WBTC: {
    symbol: 'WBTC',
    name: 'Wrapped BTC',
    decimals: 8,
    contractAddress: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599'
  },
  MLN: {
    symbol: 'MLN',
    name: 'Melon',
    decimals: 18,
    contractAddress: '0xec67005c4e498ec7f55e092bd1d35cbc47c91892'
  },
  CDT: {
    symbol: 'CDT',
    name: 'CoinDash',
    decimals: 18,
    contractAddress: '0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af'
  },
  GEN: {
    symbol: 'GEN',
    name: 'DAOStack',
    decimals: 18,
    contractAddress: '0x543ff227f64aa17ea132bf9886cab5db55dcaddf'
  },
  NPXS: {
    symbol: 'NPXS',
    name: 'Pundi X',
    decimals: 18,
    contractAddress: '0xa15c7ebe1f07caf6bff097d8a589fb8ac49ae5b3'
  },
  MYB: {
    symbol: 'MYB',
    name: 'MyBit',
    decimals: 18,
    contractAddress: '0x5d60d8d7ef6d37e16ebabc324de3be57f135e0bc'
  },
  BAM: {
    symbol: 'BAM',
    name: 'Bamboo',
    decimals: 18,
    contractAddress: '0x22b3faaa8df978f6bafe18aade18dc2e3dfa0e0c'
  },
  SPN: {
    symbol: 'SPN',
    name: 'Sapien',
    decimals: 6,
    contractAddress: '0x20f7a3ddf244dc9299975b4da1c39f8d5d75f05a'
  },
  EQUAD: {
    symbol: 'EQUAD',
    name: 'Quadrant Protocol',
    decimals: 18,
    contractAddress: '0xc28e931814725bbeb9e670676fabbcb694fe7df2'
  },
  UPP: {
    symbol: 'UPP',
    name: 'Sentinel Protocol',
    decimals: 18,
    contractAddress: '0xc86d054809623432210c107af2e3f619dcfbf652'
  },
  CND: {
    symbol: 'CND',
    name: 'Cindicator',
    decimals: 18,
    contractAddress: '0xd4c435f5b09f855c3317c8524cb1f586e42795fa'
  },
  USDT: {
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 6,
    contractAddress: '0xdac17f958d2ee523a2206206994597c13d831ec7'
  },
  SNX: {
    symbol: 'SNX',
    name: 'Synthetix Network Token',
    decimals: 18,
    contractAddress: '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f'
  }
};
